// extracted by mini-css-extract-plugin
export default {"divider":"Thread_divider__f6sJU"};